import React, { useRef, useEffect, forwardRef } from 'react';
import { Grid ,Button} from "@mui/material";
import { useReactToPrint } from 'react-to-print';
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';
import Ppmreport from './Ppmreport';
import "../commoncomponents/printing.css"; 

const Ppmcalenderdownload = forwardRef((props, ref) => {
  const { reportdata, onRenderComplete, setOpenModal, year ,service, hospitalname,month,workgroup} = props;
  const printRef = useRef();
  const accessData = useAccess();
  const access = utilities.getScreenPermissions(accessData, "ENGA008");

  useEffect(() => {
    if (onRenderComplete) {
      onRenderComplete();
    }
  }, [onRenderComplete]);

  useEffect(() => {
    if (printRef.current) {
      printRef.current.style.width = '100%';
      printRef.current.style.height = 'auto'; // Ensure it adjusts dynamically to fit content
      printRef.current.style.overflow = 'visible'; 
    }
  }, [reportdata]);
  
  const handlePrint = useReactToPrint({
    content: () => printRef.current,

    onBeforePrint: () => {
      if (printRef.current) {
        printRef.current.classList.add("printable-area");
      }
    },
    onAfterPrint: () => {
      if (printRef.current) {
        printRef.current.classList.remove("printable-area");
      }
    },
  }); 
  
 const handleClose = () => {
    if (setOpenModal) {
      setOpenModal(false);
    }
  };

 
  return (
    <>
    
        {/* <Grid
          container
          style={{
            flexGrow: 1,
            padding: '16px',
            overflow: 'auto',
          }}
          justifyContent="flex-start"
          alignItems="flex-start"
        > */}
             <Grid container justifyContent="flex-end" spacing={2} >
       
          <Grid item>
            <Button variant="contained" onClick={handlePrint}>Print</Button>
          </Grid>
        <Grid item>
          <Button variant="contained" onClick={handleClose}>Close</Button>
        </Grid>

          <Ppmreport ref={printRef} 
          year={year} 
          workgroup={workgroup}
          reportdata={reportdata}
           service={service}
           month={month}
           hospitalname={hospitalname}
           className="pdf-content" />
        </Grid>
    
    </>
  );
});

export default Ppmcalenderdownload;

